import { cleanStorage } from 'auth/storage';

const logOut = () => {
  cleanStorage();
  window.location.reload();
};

export default logOut;
